import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, Routes, Route } from "react-router-dom";
import Layout from "../../../common_comp/Layout/Layout";
import Submit from "./Submit";
import AfterSubmission from "./AfterSubmission";
import PeerReview from "./Peerreview";
import DoubleReview from "./DoubleReview";
import ReviewReport from "./ReviewReport";
import Ethnical from "./Ethnical";
import TimeSchedule from "./Timeschedule";
import Appeals from "./Appeals";
import AfterAcceptance from "./Afteracceptance";
import ArticleProof from "./Articleproof";
import Decision from "./Decision";

const EditorialDash = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Ensures smooth scrolling
    });
  };

  return (
    <>
      <Layout>
        <Container fluid>
          <Row>
            <Col lg={3} sm={12} className="dashboard_layout">
              <Nav className="flex-column">
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/0--how-to-submit-an-article-"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  How to submit an Article
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/1-after-submission"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  After Submission
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/2-peer-review"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Peer Review
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/3-double-blind-peer-review"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Double-blind peer-review
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/4--referees-peer-review-reports-"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Referee's peer review reports
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/5-ethical-peer-reviewing"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Ethical peer-reviewing
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/6-time-schedule"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Time Schedule
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/7-decisions"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Decisions{" "}
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/8--appeals-"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Appeals{" "}
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/9-after-acceptance"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  After Acceptance{" "}
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/editorial-criteria-and-processes/10-article--proofs--"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  Article Proof{" "}
                </Nav.Link>
              </Nav>
            </Col>

            {/* Main Content Area */}
            <Col
              lg={8}
              sm={12}
              className="dashboard_content"
              // style={{
              //   padding: "2rem",
              //   // height: "100vh",
              //   // overflowY: "auto",
              // }}
            >
              <Routes>
              <Route
                  path="/"
                  element={<Submit />}
                />
                <Route
                  path="/0--how-to-submit-an-article-"
                  element={<Submit />}
                />
                <Route
                  path="/1-after-submission"
                  element={<AfterSubmission />}
                />
                <Route path="/2-peer-review" element={<PeerReview />} />
                <Route
                  path="/3-double-blind-peer-review"
                  element={<DoubleReview />}
                />
                <Route
                  path="/4--referees-peer-review-reports-"
                  element={<ReviewReport />}
                />
                <Route
                  path="/5-ethical-peer-reviewing"
                  element={<Ethnical />}
                />
                <Route path="/6-time-schedule" element={<TimeSchedule />} />
                <Route path="/7-decisions" element={<Decision />} />
                <Route path="/8--appeals-" element={<Appeals />} />
                <Route path="/9-after-acceptance" element={<AfterAcceptance />} />
                <Route path="/10-article--proofs--" element={<ArticleProof />} />
              </Routes>
            </Col>
          </Row>
        </Container>
      </Layout>
    </>
  );
};

export default EditorialDash;
